export default "__VITE_ASSET__BYrXDM2___"